/**
 * Single source of design tokens for new feature code. (Legacy files still hold
 * their own copy-pasted `C` object; those converge here during dedup — new code
 * imports from this module rather than redefining tokens.)
 */
export const tokens = Object.freeze({
  accent: "#FF5A00",
  accentL: "#FFF0ED",
  bg: "#F5F2EE",
  white: "#FFFFFF",
  border: "#E8E4DF",
  text: "#1A1A1A",
  muted: "#9B9792",
  sub: "#6B6B6B",
  success: "#15803D",
  error: "#DC2626",
  warning: "#B45309",
});

export default tokens;
